import React, { useContext, useState } from 'react'
import Alert from '../../atoms/Alert/Alert'
import Button from '../../atoms/Button/Button'
import Banner from '../../atoms/Banner/Banner'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import { CartContext } from '../../../context/CartContext'
import UploadLoghi, { _uploadLoghi } from '../UploadLoghi/UploadLoghi'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import LoadingSvg from '../../atoms/Loading/Loading'
import useTrans from '../../../hooks/useTrans'
import _ from 'lodash'
import { numberNotation } from '../../../utils/safe'

const UploadModal = ({
  isVisible,
  setVisible,
  uploadInfo,
  cartMain,
  CheckErroriCarrello,
  t,
  markAsChanged,
}) => {
  const [files, setFiles] = useState(null)
  const [Loading, setLoading] = useState(false)
  const [success, setSuccess] = useState()

  const posizioni = cartMain
    ? cartMain.personalizzazioni_carrello.filter(
        (personalizzazione) => personalizzazione?.id === uploadInfo.personalizzazione_id
      )[0]?.stesso_logo
      ? [0]
      : [0, 1]
    : null

  const isDisabled = () => {
    if (files) {
      return posizioni.length === Object.values(files).length ? false : true
    }
    return true
  }

  const _handleSubmit = () => {
    const files_to_upload = Object.values(files)
    uploadInfo?.id_posizioni?.forEach(
      async (id, index) =>
        await _uploadLoghi({
          id: id,
          file_to_upload: files_to_upload[index],
          setLoading: setLoading,
        })
          .then((res) => {
            setSuccess(true)
            displayNotification(
              'upload.logo.success',
              t('Hai caricato correttamenti i Loghi'),
              'success'
            )
          })
          .catch((err) => displayNotification('upload.loghi.error', err.message, 'error'))
    )
  }

  return !success ? (
    <NewModal
      visible={isVisible}
      onClose={() => setVisible(false)}
      title={t('Carica i Loghi')}
      actions={
        Loading
          ? []
          : [
              <Button
                onClick={() => setVisible(false)}
                variant="secondary"
                size="medium"
                label={t('Chiudi')}
              />,
              <Button
                onClick={_handleSubmit}
                variant="primary"
                size="medium"
                label={t('Carica Loghi')}
                disabled={isDisabled()}
              />,
            ]
      }
    >
      <p
        className="posizione__actions__top"
        style={{
          textTransform: 'uppercase',
          marginBottom: 5,
          fontWeight: 700,
          color: '#8891a1',
        }}
      >
        {
          cartMain?.personalizzazioni_carrello?.filter(
            (riga) => riga?.id === uploadInfo?.personalizzazione_id
          )[0]?.nome_lavorazione
        }
      </p>
      <UploadLoghi posizioni={posizioni ? posizioni : [0]} setFromProps={setFiles} />
      {Loading && <LoadingSvg />}
    </NewModal>
  ) : (
    <NewModal
      visible={isVisible}
      title={t('Hai caricato i Loghi con Successo')}
      actions={[
        <Button
          variant="primary"
          label={t('Chiudi')}
          onClick={() => {
            markAsChanged
              ? markAsChanged(true)
              : (CheckErroriCarrello(), setSuccess(null), setVisible(false))
          }}
        />,
      ]}
    />
  )
}

const MercePrenotataModal = ({ isVisible, setVisible, articoli, t }) => {
  const codice_articoli = articoli.map((articolo) => articolo.articolo.codice)

  return (
    <NewModal
      title={t("L'ordine contiene merce prenotata")}
      text={
        <p>
          {t('La quantità inserita per')}
          {codice_articoli?.length > 1 ? t(` gli articoli`) : t(` il codice prodotto`)}
          <strong>{' ' + codice_articoli + ' '}</strong>
          {t(
            "non è disponibile subito, e verrà prenotata. L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste"
          )}
        </p>
      }
      visible={isVisible}
      onClose={() => setVisible(false)}
      actions={[
        <Button
          label={t('Chiudi')}
          variant="secondary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    >
      <ModalBlocks.ProssimiArrivi articoli={articoli} />
    </NewModal>
  )
}

const CartAlerts = ({ errori, setOpenModalQuantita, setId, CheckErroriCarrello, saveCodice }) => {
  const { cartMain } = useContext(CartContext)
  const [showUpload, setShowUpload] = useState(false)
  const [uploadInfo, setUploadInfo] = useState()
  const [isVisible, setVisible] = useState(false)
  const [articoli, setArticoli] = useState([])
  const t = useTrans()

  const getPlaceholder = (errore) => {
    switch (errore.tipo) {
      case 'non_prenotabile':
        return {
          placeholder: t(
            "La disponibilità dell'articolo {0} è variata e non soddisfa la quantità inserita.",
            [errore.riga.articolo.codice]
          ),
          link: t('Modifica quantità'),
          alert: errore.bloccante,
        }
      case 'non_disponibile':
        return {
          placeholder: t(" La disponibilità dell'articolo {0} è variata.", [
            errore.riga.articolo.codice,
          ]),
          link: t('Controlla e modifica quantità'),
          alert: errore.bloccante,
        }
      case 'no_multipli':
        return {
          placeholder: t(
            "L'articolo {0} contiene sfusi. Ordina per imballi e/o sotto imballi per ottenere uno sconto del 2%.",
            [errore.riga.articolo.codice]
          ),
          link: t('Modifica quantità'),
          alert: errore.bloccante,
        }
      case 'no_multipli_bloccante':
        return {
          placeholder: t("L'articolo {0} è acquistabile solo a multipli di {1} pezzi.", [
            errore.riga.articolo.codice,
            errore?.quantita_minima_personalizzabile,
          ]),
          link: t('Modifica quantità'),
          alert: errore.bloccante,
        }
      case 'quantita_minima_personalizzabile':
        return {
          placeholder: t(
            ' ' +
              `nella lavorazione {0} non viene raggiunta la quantità minima personalizzabile di {1} pezzi.` +
              ' ',
            [errore?.nome_lavorazione, errore?.quantita_minima_personalizzabile]
          ),
          alert: errore.bloccante,
          noClick: true,
        }
      case 'quantita_massima_personalizzabile':
        return {
          placeholder: t(
            ' ' +
              `nella lavorazione {0}, se desideri personalizzare una quantità maggiore di {1} pz, contatta l'ufficio commerciale così che possa studiare una proposta mirata e verificare i tempi di consegna.` +
              ' ',
            [errore?.nome_lavorazione, numberNotation(errore?.quantita_massima_personalizzabile)]
          ),
          alert: errore.bloccante,
          noClick: true,
        }
      case 'no_logo':
        return {
          placeholder: t(' ' + `nella lavorazione {0} non è stato caricato il logo.` + ' ', [
            cartMain?.personalizzazioni_carrello?.filter(
              (personalizzazione) => personalizzazione.id === errore.personalizzazione_id
            )[0]?.nome_lavorazione,
          ]),
          link: t('Inserisci Logo'),
          alert: errore.bloccante,
        }
      case 'no_spedizione_gratis':
        return {
          placeholder: t(
            `Risparmia il costo della spedizione ordinando almeno {0} Euro di merce a imballi e sotto imballi originali!`,
            [errore?.importo_spedizione_gratuita]
          ),
          link: null,
          alert: errore.bloccante,
          noClick: true,
        }
      case 'contiene_prenotazione':
        return {
          placeholder: t(`L'ordine contiene merce prenotata`),
          link: t('Visualizza merce prenotata'),
          alert: errore.bloccante,
        }
    }
  }

  return (
    <div>
      {errori &&
        errori.map((errore, index) => (
          <div style={{ marginBottom: 15 }} key={`cart-alert-${index}`}>
            <Alert
              full
              noClick={getPlaceholder(errore)?.noClick}
              variant={!getPlaceholder(errore)?.alert && 'info'}
              onClick={() => {
                saveCodice && saveCodice(errore?.riga?.articolo?.codice)
                if (errore.tipo === 'no_logo') {
                  setUploadInfo(errore)
                  setShowUpload(true)
                } else if (
                  errore?.tipo === 'no_spedizione_gratis' ||
                  errore?.tipo === 'quantita_minima_personalizzabile' ||
                  errore?.tipo === 'quantita_massima_personalizzabile'
                ) {
                } else {
                  errore.tipo !== 'contiene_prenotazione'
                    ? (setId(errore.riga.id), setOpenModalQuantita(true))
                    : (setVisible(true), setArticoli(errore?.righe))
                }
              }}
              placeholder={getPlaceholder(errore)?.placeholder}
              link={getPlaceholder(errore)?.link}
            />
          </div>
        ))}
      <MercePrenotataModal
        isVisible={isVisible}
        setVisible={setVisible}
        articoli={articoli}
        t={t}
      />
      {uploadInfo && (
        <UploadModal
          isVisible={showUpload}
          setVisible={setShowUpload}
          uploadInfo={uploadInfo}
          cartMain={cartMain}
          CheckErroriCarrello={CheckErroriCarrello}
          t={t}
        />
      )}
    </div>
  )
}

export default CartAlerts

export const LoghiMancantiModal = ({
  loghiMancanti,
  CheckErroriCarrello,
  cartMain,
  setLoghiMancanti,
}) => {
  const t = useTrans()
  return loghiMancanti?.map((logoMancante, i) => (
    <UploadModal
      markAsChanged={(value) => {
        const newLoghiMancanti = [...loghiMancanti]
        _.set(newLoghiMancanti[i], 'visibile', false)
        _.set(newLoghiMancanti[i], 'changed', value)
        setLoghiMancanti(newLoghiMancanti)
      }}
      isVisible={logoMancante?.visibile}
      setVisible={(value) => {
        const newLoghiMancanti = [...loghiMancanti]
        _.set(newLoghiMancanti[i], 'visibile', value)
        setLoghiMancanti(newLoghiMancanti)
      }}
      uploadInfo={logoMancante}
      cartMain={cartMain}
      t={t}
      CheckErroriCarrello={CheckErroriCarrello}
    />
  ))
}
